import { getDataMapper, mapField } from "@/shared";

export const mapRobokassaFromServer = getDataMapper({
    paymentUrl: mapField("payment_url"),
    paymentData: mapField("payment_data"),
});
